import { useEffect, useState } from "react";
import { createFileRoute, Link, useLocation } from "@tanstack/react-router";

import { ScreenSpinner } from "@/components";
import { Button } from "@/ui";

const NotFound = () => {
  const location = useLocation() as {
    state: { title: string | undefined; message: string | undefined };
  };
  const [isLoading, setIsLoading] = useState(true);

  const title = location.state?.title;
  const message = location.state?.message;

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
  }, []);

  if (isLoading) {
    return <ScreenSpinner />;
  }

  return (
    <section className="relative flex h-full flex-col items-center justify-center bg-surface-sunken px-6 text-center">
      <div className="absolute text-[40vw] font-bold text-content-subtle transition-all">404</div>

      <div className="z-10 flex flex-col items-center gap-4">
        <p className="text-4xl font-bold">{title ?? "So sorry!"}</p>

        <p>{message ?? "The page you are looking for cannot be found"}</p>

        <Button size="sm" variant="primary" asChild>
          <Link to="/">Back to Home</Link>
        </Button>
      </div>
    </section>
  );
};

export const Route = createFileRoute("/_private/(with-footer)/$/")({ component: NotFound });
